import {
  GET_TRM_CONFIGURATIONS,
  GET_TRM_CONFIGURATIONS_SUCCESS,
  GET_TRM_CONFIGURATIONS_FAIL,
  PUT_TRM_CONFIGURATIONS,
  PUT_TRM_CONFIGURATIONS_SUCCESS,
  PUT_TRM_CONFIGURATIONS_FAIL,
  TRM_CONFIGURATIONS_RESET
} from '../../actions/trm/systemConfiguration';

export const initialState = {
  isLoading: false,
  data: [],
  isSaved: false,
  hasError: false
};

function systemConfiguration(state = initialState, action) {
  switch (action.type) {
    case GET_TRM_CONFIGURATIONS:
      return {
        ...state,
        isLoading: true,
        data: [],
        hasError: false,
        isSaved: false
      };
    case GET_TRM_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        data: action.payload,
        isSaved: false
      };
    case GET_TRM_CONFIGURATIONS_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        isSaved: false
      };
    case PUT_TRM_CONFIGURATIONS:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        isSaved: false
      };
    case PUT_TRM_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        data: action.payload.data,
        isSaved: true
      };
    case PUT_TRM_CONFIGURATIONS_FAIL:
      return {
        ...state,
        isLoading: false,
        isSaved: false,
        hasError: true
      };
    case TRM_CONFIGURATIONS_RESET:
      return { ...initialState };
    default:
      return state;
  }
}

export default systemConfiguration;
